"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWarehouse = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const warehouse_1 = require("../fragments/warehouse");
exports.createWarehouse = (0, graphql_tag_1.default) `
  ${warehouse_1.warehouseDetailsFragment}
  ${warehouse_1.warehouseErrorFragment}
  mutation CreateWarehouse($input: WarehouseCreateInput!) {
    createWarehouse(input: $input) {
      errors {
        ...WarehouseError
      }
      warehouse {
        ...WarehouseDetails
      }
    }
  }
`;
//# sourceMappingURL=warehouse.js.map